
<div class="w-full flex flex-row justify-center user-location-main-container">
  <div
    class="w-full max-w-1440 mx-5 location-inner-container flex justify-center items-start user-location-card-img"
    :style="{ backgroundImage: `url(${currentImage})`, opacity: imageOpacity }"
  >
  </div>
</div>
